import React, { PropsWithChildren, ReactElement } from 'react'
import { Flexbox } from '../flexbox/flexbox'

type Props = PropsWithChildren<{
  readonly title: string
}>

const Component = (props: Props): ReactElement => {
  const { title, children } = props

  return (
    <Flexbox className="mb-4">
      <h1 className="text-3xl font-bold">{title}</h1>
      {children}
    </Flexbox>
  )
}

export const ScreenTitle = React.memo(Component)